import { render } from "./StepWizard2.vue?vue&type=template&id=361a1f7d"
import script from "./StepWizard2.vue?vue&type=script&lang=js"
export * from "./StepWizard2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__